<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";

export default {
  name: "MerchantPaymentRequest",
  components: {
    Loading,
  },
  data() {
    return {
      isLoading: true,
      transaction_key: null,
      cart_amount: null,
      tax_amount: null,
      full_name: null,
      email: null,
      phone: null,
      success_url: null,
      failure_url: null,
      merchant_public_key: null,
    };
  },
  computed: {
    ...mapState(["successmessage", "errormessage", "message"]),
  },
  mounted() {
    // ✅ FIXED: Validate query parameters before processing
    this.processPaymentRequest();
  },
  methods: {
    /**
     * Validate and extract query parameters
     */
    validateQueryParameters() {
      // Extract from route query
      this.transaction_key = this.$route.query.transaction_key;
      this.cart_amount = this.$route.query.cart_amount;
      this.tax_amount = this.$route.query.tax_amount;
      this.full_name = this.$route.query.full_name;
      this.email = this.$route.query.email;
      this.phone = this.$route.query.phone;
      this.success_url = this.$route.query.success_url;
      this.failure_url = this.$route.query.failure_url;
      this.merchant_public_key = this.$route.query.merchant_public_key;

      // ✅ Check if required parameters exist
      const requiredParams = [
        "transaction_key",
        "cart_amount",
        "merchant_public_key",
        "success_url",
        "failure_url",
      ];

      const missingParams = requiredParams.filter(
        (param) => !this[param]
      );

      if (missingParams.length > 0) {
        console.error(
          "❌ Missing required query parameters:",
          missingParams
        );
        return {
          isValid: false,
          message: `Missing required parameters: ${missingParams.join(", ")}`,
        };
      }

      console.log("✅ All query parameters validated successfully");
      return { isValid: true };
    },

    /**
     * Process payment request
     */
    async processPaymentRequest() {
      try {
        // ✅ Validate query parameters first
        const validation = this.validateQueryParameters();

        if (!validation.isValid) {
          console.error("❌ Validation failed:", validation.message);
          this.isLoading = false;

          // ✅ Show error message
          this.$bvToast.toast(validation.message, {
            title: "Invalid Request",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-center",
          });

          // ✅ Redirect to home after 3 seconds
          setTimeout(() => {
            this.$router.push("/");
          }, 3000);

          return;
        }

        // ✅ Create FormData with validated parameters
        const merchantPaymentRequest = new FormData();
        merchantPaymentRequest.append("transaction_key", this.transaction_key);
        merchantPaymentRequest.append("cart_amount", this.cart_amount);
        merchantPaymentRequest.append("tax_amount", this.tax_amount || "0");
        merchantPaymentRequest.append("full_name", this.full_name || "");
        merchantPaymentRequest.append("email", this.email || "");
        merchantPaymentRequest.append("phone", this.phone || "");
        merchantPaymentRequest.append("success_url", this.success_url);
        merchantPaymentRequest.append("failure_url", this.failure_url);
        merchantPaymentRequest.append(
          "merchant_public_key",
          this.merchant_public_key
        );

        console.log("📤 Sending payment request with transaction_key:", this.transaction_key);

        // ✅ Make API call with axios
        const response = await axios.post("merchantpayment", merchantPaymentRequest, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        console.log("✅ Payment request successful:", response.data);

        if (response.status === 200 && response.data.transaction) {
          // ✅ Redirect to merchant payment page with transaction ID
          this.$router.replace({
            name: "merchant-payment",
            params: { transactionid: response.data.transaction },
          });
        } else {
          throw new Error("Invalid response from server");
        }
      } catch (error) {
        console.error("❌ Payment request error:", error);

        // ✅ Enhanced error handling
        const errorMessage = error.response?.data?.message || 
                            error.message || 
                            "Payment request failed";

        console.error("Error details:", {
          status: error.response?.status,
          data: error.response?.data,
          message: errorMessage,
          transaction_key: this.transaction_key,
        });

        this.isLoading = false;

        // ✅ Show error toast
        this.$bvToast.toast(errorMessage, {
          title: "Payment Request Failed",
          variant: "danger",
          solid: true,
          toaster: "b-toaster-top-center",
        });

        // ✅ Verify failure_url exists before redirecting
        if (this.failure_url) {
          const failureRedirectUrl = 
            `${this.failure_url}?status=fail&transaction_key=${this.transaction_key}`;
          
          console.log("🔄 Redirecting to failure URL:", failureRedirectUrl);
          
          // ✅ Redirect after 2 seconds to show error message
          setTimeout(() => {
            window.open(failureRedirectUrl, "_self");
          }, 2000);
        } else {
          console.error("❌ No failure_url provided, cannot redirect");
          
          // ✅ Fallback: redirect to home
          setTimeout(() => {
            this.$router.push("/");
          }, 3000);
        }
      }
    },
  },
};
</script>

<style scoped>
/* Ensure loading overlay covers full page */
</style>